import React from 'react';
import { CacheProvider } from './CacheProvider';

export const AnnotationsProvider = ({ children }: any) => {
	return <CacheProvider>{children}</CacheProvider>;
};
